import { PERMISSIONS } from '$app/constants'
import { ROUTE_NAMES } from '$router/config'
import { LucideIcon } from 'lucide-react'

export type MENU = {
  path: ROUTE_NAMES
  Icon: LucideIcon
  label: string
  permissions: PERMISSIONS[]
}

export type MENU_GROUP = {
  title?: string
  menus: MENU[]
}[]

export enum USER_TYPE {
  APP_USER,
  MEMBER
}
